import { Bell, Check, MessageSquare, DollarSign, Package, AlertCircle, Mail } from 'lucide-react';

const ICONS: Record<string, React.ReactNode> = {
  new_offer: <DollarSign className="h-4 w-4 text-primary" />,
  offer_accepted: <Check className="h-4 w-4 text-success" />,
  offer_declined: <AlertCircle className="h-4 w-4 text-destructive" />,
  item_sold: <Package className="h-4 w-4 text-primary" />,
  dm_received: <MessageSquare className="h-4 w-4 text-primary" />,
  inquiry_received: <Mail className="h-4 w-4 text-active-gold" />,
  system: <Bell className="h-4 w-4 text-muted-foreground" />,
};

export function getNotificationIcon(type: string): React.ReactNode {
  return ICONS[type] ?? <Bell className="h-4 w-4 text-muted-foreground" />;
}
